/**
 * Checks if an object is empty (has no properties)
 */
export function isEmptyObject<T extends object>(obj: T): boolean {
	return Object.keys(obj).length === 0;
}
